import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

const fallbackLng = ['en'];
const availableLanguages = ['en', 'id'];

const options = {
  order: ['navigator', 'htmlTag', 'path', 'subdomain'],

  lookupQuerystring: 'lng',
  lookupCookie: 'i18next',
  lookupLocalStorage: 'i18nextLng',
  lookupFromPathIndex: 0,
  lookupFromSubdomainIndex: 0,

  caches: ['localStorage', 'cookie'],
  excludeCacheFor: ['cimode'],

  cookieMinutes: 10,
  cookieDomain: 'myDomain',

  htmlTag: document.documentElement,

  checkWhitelist: true,
};

// Custom request function to minimize headers and prevent 431 errors
const customRequest = (options, url, payload, callback) => {
  // Remove any query parameters that might cause cache issues or add headers
  const cleanUrl = url.split('?')[0];
  
  // Use fetch with minimal headers for translation files
  // Create a new Request object to ensure no default headers are added
  const request = new Request(cleanUrl, {
    method: 'GET',
    credentials: 'omit', // Don't send cookies, authorization headers, etc.
    mode: 'cors',
    cache: 'default',
    headers: {
      'Accept': 'application/json',
    },
  });
  
  fetch(request)
    .then((response) => {
      if (!response.ok) {
        return callback(`${response.status} ${response.statusText}`, null);
      }
      return response.json();
    })
    .then((data) => {
      // i18next-xhr-backend expects callback(error, data) where data is the translation object
      callback(null, data);
    })
    .catch((error) => {
      callback(error.message || 'Failed to load translation', null);
    });
};

i18n
  .use(Backend)

  .use(LanguageDetector)

  .use(initReactI18next)

  .init({
    fallbackLng,
    debug: true,
    whitelist: availableLanguages,
    detection: options,

    backend: {
      loadPath: `/locales/{{lng}}/translation.json`,
      requestOptions: {
        credentials: 'omit', // Don't send cookies
      },
      // Use custom request function to minimize headers
      request: customRequest,
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
